// extracted by mini-css-extract-plugin
export default {"h5":"style_h5__IVTqr"};